/**
 * Dependencies.
 */
import EntityCommentTypeModel from '@/api/delivery-survey-entity-comment/entity-comment-type.model';
import applicationConstant from '@/modules/main/constants/application.constant';
import { BaseService } from '@/modules/main/services/base.service';

/**
 * Service.
 */
class EntityCommentTypeService extends BaseService<EntityCommentTypeModel> {
  /**
   * Constructor.
   */
  constructor() {
    super(
      EntityCommentTypeModel,
      EntityCommentTypeModel.name,
      applicationConstant.apiCustomerPublicUrl
    );
  }
}

/**
 * Export `entityCommentTypeService`.
 */
export const entityCommentTypeService = new EntityCommentTypeService();
